/** Non-blocking transient message, e.g. for geolocation feedback (DESIGN.md §7). */
export class Toast {
  readonly element: HTMLElement;
  private hideTimer: number | undefined;

  constructor() {
    this.element = document.createElement("div");
    this.element.className = "toast";
    this.element.setAttribute("role", "status");
    this.element.setAttribute("aria-live", "polite");
    this.element.hidden = true;
  }

  show(message: string, durationMs = 4000): void {
    this.element.textContent = message;
    this.element.hidden = false;
    if (this.hideTimer !== undefined) {
      window.clearTimeout(this.hideTimer);
    }
    this.hideTimer = window.setTimeout(() => {
      this.element.hidden = true;
    }, durationMs);
  }
}
